import { useEffect } from "react";

const APP_REDIRECT_URI = "dataupgamingmobile://google-auth";

export default function GoogleAuthRedirect() {
  useEffect(() => {
    window.location.replace(`${APP_REDIRECT_URI}${window.location.hash}`);
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-black px-4">
      <p className="text-gray-700 dark:text-gray-200">Completing Google sign in...</p>
    </div>
  );
}
